<div *ngIf="vm$ | async as vm">
  <!-- Share -->
  <dgx-action-button
    *ngIf="vm.canRecommend"
    class="pathway-page-actions__button"
    design="square"
    icon="arrow-forward"
    size="md"
    [isIconOnly]="true"
    [autoToggleState]="false"
    [tooltip]="'Core_Recommend' | translate"
    (click)="recommend($event)"
    dgatInput="pageActionOptions-recommend"
  ></dgx-action-button>

  <!-- Settings -->
  <dgx-menu
    *ngIf="vm.permissions.canEditPathway"
    [menuConfig]="settingsMenuConfig"
  >
    <dgx-action-button
      class="pathway-page-actions__button"
      design="square"
      icon="gear"
      size="md"
      [isIconOnly]="true"
      [autoToggleState]="false"
      [tooltip]="'Core_Settings' | translate"
      dgatInput="pageActionOptions-settings"
    ></dgx-action-button>
  </dgx-menu>

  <!-- Edit/Done -->
  <dgx-action-button
    *ngIf="vm.permissions.canEditPathway"
    class="pathway-page-actions__button"
    design="square"
    icon="{{ vm.isEditMode ? '' : 'pencil' }}"
    size="md"
    (click)="toggleEditMode()"
    [isActive]="vm.isEditMode"
    [autoToggleState]="false"
    dgatInput="pageActionOptions-editMode"
  >
    {{
      (vm.isEditMode ? 'Core_DoneEditing' : 'Pathways_EditPathway') | translate
    }}
  </dgx-action-button>

  <!-- Follow/Following -->
  <dgx-action-button
    #enrollment
    class="pathway-page-actions__button"
    *ngIf="!vm.isEditMode"
    design="square"
    icon="{{ vm.pathway.isEnrolled ? 'checkmark' : 'plus' }}"
    size="md"
    [isIconOnly]="true"
    (click)="toggleEnrollment()"
    [isActive]="vm.pathway.isEnrolled"
    [autoToggleState]="false"
    [tooltip]="
      (vm.pathway.isEnrolled ? 'Core_Following' : 'Core_Follow') | translate
    "
    dgatInput="pageActionOptions-follow"
  ></dgx-action-button>
</div>
